// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.invn {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .invn {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .invn {
    padding: 16px 16px 28px;
  }
}

.invn-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
  color: #ccc;
  flex-wrap: wrap;
}
.invn-breadcrumb li {
  display: flex;
  align-items: center;
}
.invn-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.invn-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
}
.invn-breadcrumb li a:hover {
  color: rgb(0, 173, 208);
}
.invn-breadcrumb li.is-current {
  color: #6d6e71;
  font-weight: 600;
}

.invn-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}
@media (max-width: 640px) {
  .invn-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

.invn-title {
  font-size: 26px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.2;
}
@media (max-width: 640px) {
  .invn-title {
    font-size: 21px;
  }
}

.invn-header__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.invn-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  color: #676a6c;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}
.invn-btn:hover {
  background: #f1f1f2;
  border-color: #ccc;
}

.invn-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 22px;
  margin: -12px 0 20px;
}
.invn-meta__item {
  display: inline-flex;
  align-items: baseline;
  gap: 7px;
}
.invn-meta__k {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #ccc;
  white-space: nowrap;
}
.invn-meta__v {
  font-size: 13px;
  font-weight: 600;
  color: #6d6e71;
}

.invn-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}
@media (max-width: 767px) {
  .invn-stats {
    grid-template-columns: 1fr;
  }
}

.invn-stat {
  background: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  padding: 14px 16px;
}

.invn-stat__label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #ccc;
  display: block;
  margin-bottom: 8px;
}

.invn-stat__big {
  font-size: 24px;
  font-weight: 700;
  color: #6d6e71;
  line-height: 1;
  margin-bottom: 12px;
}

.invn-stat__sub {
  font-size: 12px;
  font-weight: 500;
  color: #ccc;
  margin-left: 6px;
}

.invn-keys__add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 173, 208, 0.06);
  border: 1px dashed rgba(0, 173, 208, 0.4);
  color: rgb(0, 173, 208);
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}
.invn-keys__add:hover {
  background: rgba(0, 173, 208, 0.12);
  border-style: solid;
}

.invn-promo {
  border-color: rgba(105, 190, 40, 0.35);
  background: linear-gradient(150deg, rgba(105, 190, 40, 0.09), rgba(105, 190, 40, 0.03));
}
.invn-promo__pitch {
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.45;
  color: #676a6c;
}
.invn-promo__pitch strong {
  font-weight: 700;
  color: #48831c;
}
.invn-promo__pitch--lead {
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.4;
}
.invn-promo__cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #fff;
  background: rgb(105, 190, 40);
  border: 1px solid rgb(105, 190, 40);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.invn-promo__cta:hover {
  background: #569c21;
  border-color: #569c21;
}
.invn-promo__cta:focus-visible {
  outline: 2px solid #4d8b1d;
  outline-offset: 2px;
}
.invn-promo.is-on {
  background: rgba(105, 190, 40, 0.07);
}
.invn-promo.is-on .invn-promo__pitch {
  margin-bottom: 0;
  color: #ccc;
}
.invn-promo__big {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #48831c;
}
.invn-promo__inf {
  font-size: 26px;
  line-height: 1;
  font-weight: 400;
}

.invn-card {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  padding: 18px 20px;
  margin-bottom: 16px;
}

.invn-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  flex-wrap: wrap;
  gap: 10px;
}

.invn-card__title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
}

.invn-tools {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.invn-select {
  padding: 7px 10px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 12px;
  background: #fff;
}

.invn-search {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.invn-search i {
  position: absolute;
  left: 10px;
  color: #ccc;
  font-size: 12px;
}
.invn-search input {
  height: 34px;
  box-sizing: border-box;
  padding: 7px 10px 7px 28px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 12px;
  min-width: 200px;
  outline: none;
}

.invn-table {
  width: 100%;
  border-collapse: collapse;
}
.invn-table thead tr {
  background: #f1f1f2;
}
.invn-table thead th {
  padding: 10px 14px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  border-bottom: 2px solid #e7eaec;
  text-align: left;
}
.invn-table tbody td {
  padding: 10px 14px;
  font-size: 13px;
  color: #676a6c;
  border-bottom: 1px solid #e7eaec;
}
.invn-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.5);
}

.invn-num {
  text-align: center;
}
.invn-num.is-neg {
  color: rgb(245, 67, 89);
}

.invn-empty {
  text-align: center;
  color: #ccc;
  padding: 16px;
}

.invn-pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
  font-size: 12px;
  color: #ccc;
}

.invn-pager__btn {
  width: 28px;
  height: 28px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
}
.invn-pager__btn[disabled] {
  opacity: 0.4;
  cursor: not-allowed;
}

.invkm {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px 20px;
}
@media only screen and (min-width: 768px) {
  .invkm {
    padding-left: 240px;
  }
}

.invkm__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 0;
}

.invkm__card {
  position: relative;
  z-index: 1;
  width: min(500px, 100%);
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.invkm__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f1f1f2, #ececed);
  border-bottom: 1px solid #e7eaec;
}

.invkm__header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgb(105, 190, 40);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.invkm__title {
  font-size: 15px;
  font-weight: 700;
  color: #6d6e71;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 0;
  line-height: 1.3;
}

.invkm__subtitle {
  font-size: 12px;
  color: #676a6c;
  margin: 2px 0 0;
  line-height: 1.3;
  opacity: 0.7;
}

.invkm__close {
  margin-left: auto;
  width: 30px;
  height: 30px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ccc;
}
.invkm__close:hover {
  background: rgba(245, 67, 89, 0.06);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.2);
}

.invkm__body {
  padding: 20px;
  overflow-y: auto;
}

.invkm__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #e7eaec;
}

.invkm .invkm__card--combo {
  overflow: visible;
  max-height: none;
}
.invkm .invkm__card--combo .invkm__header {
  border-radius: 12px 12px 0 0;
}
.invkm .invkm__card--combo .invkm__footer {
  border-radius: 0 0 12px 12px;
}

.invkm .invkm__body--combo {
  overflow: visible;
}

.invkm-field {
  margin-bottom: 16px;
}
.invkm-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 6px;
}
.invkm-field .form-control {
  width: 100%;
  padding: 9px 12px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  color: #676a6c;
  background: #fff;
  outline: none;
}
.invkm-field .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
}

.invkm-req {
  color: rgb(245, 67, 89);
}

.invkm-readonly {
  background: #f1f1f2 !important;
  color: #ccc;
}

.invkm-hint {
  margin: 5px 0 0;
  font-size: 11.5px;
  line-height: 1.4;
  color: #ccc;
}

.invkm-error {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: rgb(245, 67, 89);
}

.invkm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
}
.invkm-btn--primary {
  background: rgb(105, 190, 40);
  color: #fff;
}
.invkm-btn--primary:hover {
  background: #569c21;
}
.invkm-btn--primary[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.invkm-btn--ghost {
  background: none;
  color: #ccc;
  border-color: transparent;
}
.invkm-btn--ghost:hover {
  color: #676a6c;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/inventory/detail/inventory.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EACE,uBAAA;EACA,iBAAA;AA+YF;AA9YE;EAHF;IAG8B,uBAAA;EAkZ5B;AACF;AAlZE;EAJF;IAI8B,uBAAA;EAsZ5B;AACF;;AAnZA;EACE,aAAA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,UAAA;EAAY,eAAA;EAAiB,eAAA;EAAiB,WD+BlF;EC/B6G,eAAA;AA6ZjI;AA5ZE;EAAK,aAAA;EAAe,mBAAA;AAgatB;AA/ZI;EAA4B,YAAA;EAAc,aAAA;EAAe,WD6BzC;EC7BoE,eAAA;AAqaxF;AApaI;EAAI,cDqBa;ECrBe,qBAAA;AAwapC;AAxa2D;EAAU,uBDOrD;ACoahB;AA1aI;EAAe,cDyBE;ECzB0B,gBAAA;AA8a/C;;AAzaA;EAAe,aAAA;EAAe,qBAAA;EAAuB,8BAAA;EAAgC,SAAA;EAAW,mBAAA;AAibhG;AAhbE;EADF;IAC8B,sBAAA;IAAwB,uBAAA;EAqbpD;AACF;;AArbA;EAAc,eAAA;EAAiB,gBAAA;EAAkB,cDkB5B;EClBwD,SAAA;EAAW,uBAAA;EAAyB,wEDtBpG;ECsB8H,gBAAA;AA+b3I;AA9bE;EADF;IAC8B,eAAA;EAkc5B;AACF;;AAlcA;EAAwB,aAAA;EAAe,QAAA;EAAU,cAAA;AAwcjD;;AAvcA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,iBAAA;EAAmB,yBAAA;EAAiC,kBAAA;EACzG,gBAAA;EAAkB,cDQC;ECR2B,eAAA;EAAiB,gBAAA;EAAkB,wED3BtE;EC2BgG,eAAA;EAAiB,qBAAA;EAAuB,mBAAA;AAsdrJ;AArdE;EAAU,mBDeU;ECfwB,kBDc1B;AC2cpB;;AApdA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;AAudF;AArdE;EAAU,oBAAA;EAAsB,qBAAA;EAAuB,QAAA;AA0dzD;AAzdE;EACE,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAC9D,WDDgB;ECCW,mBAAA;AA+d/B;AA7dE;EAAO,eAAA;EAAiB,gBAAA;EAAkB,cDLvB;ACuerB;;AA9dA;EAAc,aAAA;EAAe,qCAAA;EAAuC,SAAA;EAAW,mBAAA;AAqe/E;AApeE;EADF;IAC8B,0BAAA;EAwe5B;AACF;;AAxeA;EAAa,mBDRS;ECQyB,yBAAA;EAAiC,kBAAA;EAAoB,kBAAA;AA+epG;;AA9eA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,WDVtF;ECUiH,cAAA;EAAgB,kBAAA;AAwfrJ;;AAvfA;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,cDbhC;ECa4D,cAAA;EAAgB,mBAAA;AA+fjG;;AA9fA;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,WDZjC;ECY4D,gBAAA;AAqgBhF;;AApgBA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,mCAAA;EACrD,yCAAA;EAA8C,uBDpChC;ECoCuD,kBAAA;EAAoB,iBAAA;EACzF,eAAA;EAAiB,gBAAA;EAAkB,wED1DxB;EC0DkD,eAAA;EAAiB,0BAAA;AAihBhF;AAhhBE;EAAU,mCAAA;EAAwC,mBAAA;AAohBpD;;AA/gBA;EACE,sCAAA;EACA,uFAAA;AAkhBF;AAhhBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cDrCiB;ACujBrB;AAjhBI;EAAS,gBAAA;EAAkB,cAAA;AAqhB/B;AAjhBE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAmhBJ;AAhhBE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAC3C,iBAAA;EACA,eAAA;EAAiB,gBAAA;EAAkB,wEDtF1B;ECuFT,WAAA;EACA,6BDjEY;ECkEZ,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,gEAAA;AAshBJ;AArhBI;EAAU,mBAAA;EAAwC,qBAAA;AAyhBtD;AAxhBI;EAAkB,0BAAA;EAAgD,mBAAA;AA4hBtE;AAxhBE;EACE,oCAAA;AA0hBJ;AAzhBI;EAAqB,gBAAA;EAAkB,WD1DvB;ACulBpB;AA3hBE;EAAS,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,cAAA;AAiiBhE;AAhiBE;EAAS,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AAqiB5C;;AAjiBA;EAAa,gBAAA;EAAkB,yBAAA;EAAiC,kBAAA;EAAoB,kBAAA;EAAoB,mBAAA;AAyiBxG;;AAxiBA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,mBAAA;EAAqB,eAAA;EAAiB,SAAA;AAijB7H;;AAhjBA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,cDrErF;AC6nBrB;;AAvjBA;EAAc,aAAA;EAAe,QAAA;EAAU,mBAAA;EAAqB,eAAA;AA8jB5D;;AA7jBA;EAAe,iBAAA;EAAmB,yBAAA;EAAiC,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;AAqkBxG;;AApkBA;EAAe,kBAAA;EAAoB,oBAAA;EAAsB,mBAAA;AA0kBzD;AAzkBE;EAAI,kBAAA;EAAoB,UAAA;EAAY,WDvElB;ECuE6C,eAAA;AA+kBjE;AA9kBE;EAAQ,YAAA;EAAc,sBAAA;EAAwB,0BAAA;EAA4B,yBAAA;EAAiC,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,aAAA;AAwlBpK;;AArlBA;EACE,WAAA;EAAa,yBAAA;AAylBf;AAxlBE;EAAW,mBD5ES;ACuqBtB;AA1lBE;EAAW,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,cDhFlG;ECgF8H,gCAAA;EAAwC,gBAAA;AAomB3L;AAnmBE;EAAW,kBAAA;EAAoB,eAAA;EAAiB,cDtF7B;ECsFyD,gCAAA;AAymB9E;AAxmBE;EAAiB,oCAAA;AA2mBnB;;AAvmBA;EAAY,kBAAA;AA2mBZ;AA3mBgC;EAAW,uBDtGzB;ACotBlB;;AA7mBA;EAAc,kBAAA;EAAoB,WDrFd;ECqFyC,aAAA;AAmnB7D;;AAlnBA;EAAc,aAAA;EAAe,mBAAA;EAAqB,yBAAA;EAA2B,SAAA;EAAW,gBAAA;EAAkB,eAAA;EAAiB,WDtFvG;ACktBpB;;AA3nBA;EAAmB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;AAooBrH;AApoBsI;EAAc,YAAA;EAAc,mBAAA;AAwoBlK;;AAtoBA;EAAS,eAAA;EAAiB,QAAA;EAAU,eAAA;EAAiB,aAAA;EAAe,uBAAA;EAAyB,uBAAA;EAAyB,kBAAA;AAgpBtH;AA/oBE;EADF;IACyB,mBAAA;EAmpBvB;AACF;;AAnpBA;EAAkB,eAAA;EAAiB,QAAA;EAAU,+BAAA;EAA8B,UAAA;AA0pB3E;;AAzpBA;EAAe,kBAAA;EAAoB,UAAA;EAAY,uBAAA;EAAyB,+BAAA;EAAiC,aAAA;EAAe,sBAAA;EACtH,gBAAA;EAAkB,mBAAA;EAAqB,0EAAA;EAAsE,gBAAA;AAqqB/G;;AApqBA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAC9D,qDAAA;EAA6F,gCAAA;AA4qB/F;;AA3qBA;EAAsB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,6BDnHrD;ECmHiF,WAAA;EAAa,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,cAAA;AAwrB5L;;AAvrBA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cDnG9B;ECmG0D,wED3IlE;EC2I4F,SAAA;EAAW,gBAAA;AAgsBpH;;AA/rBA;EAAmB,eAAA;EAAiB,cDzGf;ECyG2C,eAAA;EAAiB,gBAAA;EAAkB,YAAA;AAusBnG;;AAtsBA;EAAgB,iBAAA;EAAmB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,WDnGhN;ACwzBpB;AAptBE;EAAU,mCAAA;EAA0C,uBDtHpC;ECsH6D,oCAAA;AAytB/E;;AAxtBA;EAAe,aAAA;EAAe,gBAAA;AA6tB9B;;AA5tBA;EAAiB,aAAA;EAAe,yBAAA;EAA2B,SAAA;EAAW,kBAAA;EAAoB,6BAAA;AAouB1F;;AA3tBA;EACE,iBAAA;EACA,gBAAA;AA8tBF;AA3tBE;EAAiB,4BAAA;AA8tBnB;AA7tBE;EAAiB,4BAAA;AAguBnB;;AA9tBA;EAA6B,iBAAA;AAkuB7B;;AAjuBA;EAAe,mBAAA;AAquBf;AApuBE;EAAQ,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,cD3H3F;EC2HuH,kBAAA;AA6uB5I;AA5uBE;EAAgB,WAAA;EAAa,iBAAA;EAAmB,eAAA;EAAiB,yBAAA;EAAiC,kBAAA;EAAoB,cDjInG;ECiI+H,gBAAA;EAAkB,aAAA;AAsvBtK;AArvBI;EAAU,8BDhJE;ECgJ4B,4CAAA;AAyvB5C;;AAxvBA;EAAa,uBD9IK;AC04BlB;;AA3vBA;EAAkB,8BAAA;EAA6C,WD7H3C;AC63BpB;;AA/vBA;EAAc,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;EAAkB,WD9HhD;ACo4BpB;;AArwBA;EAAe,SAAA;EAAW,eAAA;EAAiB,gBAAA;EAAkB,uBDjJ3C;AC65BlB;;AA3wBA;EAAa,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EAAkB,wED1KpI;EC0K8J,6BAAA;EAA+B,kBAAA;EAAoB,eAAA;AAyxB9N;AAxxBE;EAAa,6BDpJC;ECoJ2B,WAAA;AA4xB3C;AA5xBwD;EAAU,mBAAA;AA+xBlE;AA/xB4G;EAAc,YAAA;EAAc,mBAAA;AAmyBxI;AAlyBE;EAAW,gBAAA;EAAkB,WDlIX;ECkIsC,yBAAA;AAuyB1D;AAvyBqF;EAAU,cDzI1E;ACm7BrB","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../assets/styles/variables\";\n\n// Page frame — same content padding/max-width as the orgs listing & invitation detail\n.invn {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n// Breadcrumb — matches the invitation detail\n.invn-breadcrumb {\n  display: flex; align-items: center; list-style: none; padding: 0; margin: 0 0 8px; font-size: 12px; color: $color-neutral-mid; flex-wrap: wrap;\n  li { display: flex; align-items: center;\n    &:not(:last-child)::after { content: '/'; margin: 0 8px; color: $color-neutral-mid; font-size: 11px; }\n    a { color: $body-content-color; text-decoration: none; &:hover { color: $clarify-color; } }\n    &.is-current { color: $color-neutral-dark; font-weight: 600; }\n  }\n}\n\n// Header — large title + action button (matches invitation detail)\n.invn-header { display: flex; align-items: flex-end; justify-content: space-between; gap: 16px; margin-bottom: 24px;\n  @media (max-width: 640px) { flex-direction: column; align-items: flex-start; } }\n.invn-title { font-size: 26px; font-weight: 700; color: $color-neutral-dark; margin: 0; letter-spacing: -0.02em; font-family: $font-stack; line-height: 1.2;\n  @media (max-width: 640px) { font-size: 21px; } }\n.invn-header__actions { display: flex; gap: 8px; flex-shrink: 0; }\n.invn-btn {\n  display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border: 1px solid $color-grey-1; border-radius: 6px;\n  background: #fff; color: $body-content-color; font-size: 13px; font-weight: 600; font-family: $font-stack; cursor: pointer; text-decoration: none; white-space: nowrap;\n  &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; }\n}\n\n// Account facts — reference data about the account, so it reads quieter than the balance\n// tiles below it, which are the things you act on.\n.invn-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 22px;\n  margin: -12px 0 20px;\n\n  &__item { display: inline-flex; align-items: baseline; gap: 7px; }\n  &__k {\n    font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em;\n    color: $color-neutral-mid; white-space: nowrap;\n  }\n  &__v { font-size: 13px; font-weight: 600; color: $color-neutral-dark; }\n}\n\n// Key-balance tiles — match invitation detail stat tiles\n.invn-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 16px;\n  @media (max-width: 767px) { grid-template-columns: 1fr; } }\n.invn-stat { background: $color-neutral-light; border: 1px solid $color-grey-1; border-radius: 8px; padding: 14px 16px; }\n.invn-stat__label { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: $color-neutral-mid; display: block; margin-bottom: 8px; }\n.invn-stat__big { font-size: 24px; font-weight: 700; color: $color-neutral-dark; line-height: 1; margin-bottom: 12px; }\n.invn-stat__sub { font-size: 12px; font-weight: 500; color: $color-neutral-mid; margin-left: 6px; }\n.invn-keys__add {\n  display: inline-flex; align-items: center; gap: 6px; background: rgba($clarify-color, 0.06);\n  border: 1px dashed rgba($clarify-color, 0.4); color: $clarify-color; border-radius: 6px; padding: 6px 12px;\n  font-size: 12px; font-weight: 600; font-family: $font-stack; cursor: pointer; transition: all 0.15s ease;\n  &:hover { background: rgba($clarify-color, 0.12); border-style: solid; }\n}\n\n// Team reports tile — an offer while capped, an entitlement once unlimited. Tinted enough to\n// read as a promo, quiet enough not to shout over the balances it sits beside.\n.invn-promo {\n  border-color: rgba($develop-color, 0.35);\n  background: linear-gradient(150deg, rgba($develop-color, 0.09), rgba($develop-color, 0.03));\n\n  &__pitch {\n    margin: 0 0 10px;\n    font-size: 12px;\n    line-height: 1.45;\n    color: $body-content-color;\n    strong { font-weight: 700; color: darken($develop-color, 14%); }\n  }\n\n  // With no balance above it, the pitch is the tile's headline — size it to carry that.\n  &__pitch--lead {\n    margin-top: 4px;\n    font-size: 14px;\n    line-height: 1.4;\n  }\n\n  &__cta {\n    display: inline-flex; align-items: center; gap: 6px;\n    padding: 6px 14px;\n    font-size: 12px; font-weight: 600; font-family: $font-stack;\n    color: #fff;\n    background: $develop-color;\n    border: 1px solid $develop-color;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease;\n    &:hover { background: darken($develop-color, 8%); border-color: darken($develop-color, 8%); }\n    &:focus-visible { outline: 2px solid darken($develop-color, 12%); outline-offset: 2px; }\n  }\n\n  // Upgraded: the entitlement is the headline, so drop the promo tint back to a plain tile.\n  &.is-on {\n    background: rgba($develop-color, 0.07);\n    .invn-promo__pitch { margin-bottom: 0; color: $color-neutral-mid; }\n  }\n  &__big { display: inline-flex; align-items: center; gap: 8px; color: darken($develop-color, 14%); }\n  &__inf { font-size: 26px; line-height: 1; font-weight: 400; } // ∞ — FA4 has no infinity glyph\n}\n\n// Card — matches invitation detail\n.invn-card { background: #fff; border: 1px solid $color-grey-1; border-radius: 8px; padding: 18px 20px; margin-bottom: 16px; }\n.invn-card__head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; flex-wrap: wrap; gap: 10px; }\n.invn-card__title { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: $color-neutral-dark; }\n.invn-tools { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }\n.invn-select { padding: 7px 10px; border: 1px solid $color-grey-1; border-radius: 6px; font-size: 12px; background: #fff; }\n.invn-search { position: relative; display: inline-flex; align-items: center;\n  i { position: absolute; left: 10px; color: $color-neutral-mid; font-size: 12px; }\n  input { height: 34px; box-sizing: border-box; padding: 7px 10px 7px 28px; border: 1px solid $color-grey-1; border-radius: 6px; font-size: 12px; min-width: 200px; outline: none; } }\n\n// Table — matches invitation detail (zebra header, uppercase th)\n.invn-table {\n  width: 100%; border-collapse: collapse;\n  thead tr { background: $color-neutral-light; }\n  thead th { padding: 10px 14px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: $color-neutral-dark; border-bottom: 2px solid $color-grey-1; text-align: left; }\n  tbody td { padding: 10px 14px; font-size: 13px; color: $body-content-color; border-bottom: 1px solid $color-grey-1; }\n  tbody tr:hover { background: rgba(#fff, 0.5); }\n}\n// Centred, not right-aligned: it's the last column, so ranging right pushed the values\n// against the table edge and away from the rows they belong to.\n.invn-num { text-align: center; &.is-neg { color: $implement-color; } }\n.invn-empty { text-align: center; color: $color-neutral-mid; padding: 16px; }\n.invn-pager { display: flex; align-items: center; justify-content: flex-end; gap: 10px; margin-top: 12px; font-size: 12px; color: $color-neutral-mid; }\n.invn-pager__btn { width: 28px; height: 28px; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff; cursor: pointer; &[disabled] { opacity: 0.4; cursor: not-allowed; } }\n\n.invkm { position: fixed; inset: 0; z-index: 100000; display: flex; align-items: flex-start; justify-content: center; padding: 50px 20px;\n  @media #{$mobile-up} { padding-left: 240px; } }\n.invkm__overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 0; }\n.invkm__card { position: relative; z-index: 1; width: min(500px, 100%); max-height: calc(100vh - 100px); display: flex; flex-direction: column;\n  background: #fff; border-radius: 12px; box-shadow: 0 20px 60px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.04); overflow: hidden; }\n.invkm__header { display: flex; align-items: center; gap: 12px; padding: 16px 20px;\n  background: linear-gradient(135deg, $color-neutral-light, darken($color-neutral-light, 2%)); border-bottom: 1px solid $color-grey-1; }\n.invkm__header-icon { width: 36px; height: 36px; border-radius: 8px; background: $develop-color; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }\n.invkm__title { font-size: 15px; font-weight: 700; color: $color-neutral-dark; font-family: $font-stack; margin: 0; line-height: 1.3; }\n.invkm__subtitle { font-size: 12px; color: $body-content-color; margin: 2px 0 0; line-height: 1.3; opacity: 0.7; }\n.invkm__close { margin-left: auto; width: 30px; height: 30px; border: 1px solid $color-grey-1; border-radius: 6px; background: #fff; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 13px; color: $color-neutral-mid;\n  &:hover { background: rgba($implement-color, 0.06); color: $implement-color; border-color: rgba($implement-color, 0.2); } }\n.invkm__body { padding: 20px; overflow-y: auto; }\n.invkm__footer { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 20px; border-top: 1px solid $color-grey-1; }\n\n// A combobox menu is absolutely positioned, so the card's `overflow: hidden` and the body's\n// `overflow-y: auto` both clip it, and the footer then paints over what's left. This modal is\n// three fields — it never needed to scroll — so let it overflow visibly instead.\n//\n// Scoped to a modifier, and to `.invkm ...` for the extra specificity, because `.invkm__card`\n// is declared in BOTH this stylesheet and invitation-detail's. Both are ViewEncapsulation.None,\n// so they are one global rule fighting over source order; the plain modifier could lose.\n.invkm .invkm__card--combo {\n  overflow: visible;\n  max-height: none;\n\n  // The card clipped its children to the rounded corners; they now round themselves.\n  .invkm__header { border-radius: 12px 12px 0 0; }\n  .invkm__footer { border-radius: 0 0 12px 12px; }\n}\n.invkm .invkm__body--combo { overflow: visible; }\n.invkm-field { margin-bottom: 16px;\n  label { display: block; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em; color: $color-neutral-dark; margin-bottom: 6px; }\n  .form-control { width: 100%; padding: 9px 12px; font-size: 13px; border: 1px solid $color-grey-1; border-radius: 6px; color: $body-content-color; background: #fff; outline: none;\n    &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); } } }\n.invkm-req { color: $implement-color; }\n.invkm-readonly { background: $color-neutral-light !important; color: $color-neutral-mid; }\n.invkm-hint { margin: 5px 0 0; font-size: 11.5px; line-height: 1.4; color: $color-neutral-mid; }\n.invkm-error { margin: 0; font-size: 12px; line-height: 1.4; color: $implement-color; }\n.invkm-btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 9px 18px; font-size: 13px; font-weight: 600; font-family: $font-stack; border: 1px solid transparent; border-radius: 6px; cursor: pointer;\n  &--primary { background: $develop-color; color: #fff; &:hover { background: darken($develop-color, 8%); } &[disabled] { opacity: 0.5; cursor: not-allowed; } }\n  &--ghost { background: none; color: $color-neutral-mid; border-color: transparent; &:hover { color: $body-content-color; } } }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
